<shared-v2-summary class="summary" [revenue]="amount" [points]="points" [revenues]="revenues" [buttonDirection]="'DOWN'"
  [decimalRevenue]="deviceMounting?.profile?.decimalRevenue" (clickEvent)="modal.dismiss(revenues)"
  (checkOutEvent)="showAlert()" (removeItemEvent)="updatePreview()">
</shared-v2-summary>
<shared-loading *ngIf="loading"></shared-loading>